// Config for the 10 SEO landing pages. Each has unique title, description,
// H1, canonical path, breadcrumb, content and a clear CTA.
const HOME = "/";
const PREV = "/previous-result";
const COMMON = "/common-number";
const CHART = "/club-chart";

export const SEO_PAGES = [
  {
    canonicalPath: "/sunday-ground-teer-result/",
    title: "Sunday Ground Teer Result – Today's F/R & S/R Result",
    description:
      "Check the Sunday Ground Teer Result with today's First Round (F/R) and Second Round (S/R) numbers, updated the moment the official result is declared.",
    h1: "Sunday Ground Teer Result",
    breadcrumb: "Sunday Ground Teer Result",
    ctaLabel: "Check Today's Result",
    ctaTo: HOME,
    paragraphs: [
      "The Sunday Ground Teer Result is published here in two rounds every day — the First Round (F/R) and the Second Round (S/R). Each result is a two-digit number, and we update it on this site as soon as it is officially declared.",
      "To see the number for today, use the button below. It takes you straight to our homepage where the live F/R and S/R result, along with the correct date, is shown as soon as it is out. Bookmark this page to return quickly each day.",
    ],
    related: [
      { label: "Sunday Ground Teer Previous Result", to: "/sunday-ground-teer-previous-result/" },
      { label: "Sunday Ground Teer Common Number", to: "/sunday-ground-teer-common-number/" },
    ],
  },
  {
    canonicalPath: "/sunday-ground-teer-result-today/",
    title: "Sunday Ground Teer Result Today – F/R & S/R",
    description:
      "Get the Sunday Ground Teer Result Today — the latest same-day First Round and Second Round numbers, with no old or fake results ever shown.",
    h1: "Sunday Ground Teer Result Today",
    breadcrumb: "Sunday Ground Teer Result Today",
    ctaLabel: "Check Today's Result",
    ctaTo: HOME,
    paragraphs: [
      "Looking for the Sunday Ground Teer Result Today? This page always points you to the very latest same-day numbers. The First Round is announced around 4:30 PM and the Second Round around 5:30 PM (IST), and both appear on our homepage without delay.",
      "Because results change every single day, we never show an old number as today's result. If the draw for the day has not happened yet, you will simply see that the result is not declared yet — no guesses and no fake numbers.",
    ],
    related: [
      { label: "Sunday Ground Teer Result", to: "/sunday-ground-teer-result/" },
      { label: "Sunday Ground Teer Chart", to: "/sunday-ground-teer-chart/" },
    ],
  },
  {
    canonicalPath: "/ground-sunday-teer-result/",
    title: "Ground Sunday Teer Result – Today's Result",
    description:
      "Ground Sunday Teer Result refers to the same daily two-round teer numbers shown on this site. View today's F/R and S/R result in one tap.",
    h1: "Ground Sunday Teer Result",
    breadcrumb: "Ground Sunday Teer Result",
    ctaLabel: "View Today's Ground Sunday Teer Result",
    ctaTo: HOME,
    paragraphs: [
      "Many players search for 'Ground Sunday Teer Result' — it refers to the same daily two-round teer numbers you will find on this website. Whether you call it Ground Sunday Teer or Sunday Ground Teer, the F/R and S/R results shown here are one and the same.",
      "Tap the button below to open today's live result. You can also browse past numbers, the common number and the date-wise chart from the links across our site.",
    ],
    related: [
      { label: "Sunday Ground Teer Result Today", to: "/sunday-ground-teer-result-today/" },
      { label: "Sunday Ground Teer Previous Result", to: "/sunday-ground-teer-previous-result/" },
    ],
  },
  {
    canonicalPath: "/sunday-teer-result/",
    title: "Sunday Teer Result – Today's F/R & S/R",
    description:
      "The Sunday Teer Result shown in a clear, easy-to-read format. Check today's First Round and Second Round numbers quickly and accurately.",
    h1: "Sunday Teer Result",
    breadcrumb: "Sunday Teer Result",
    ctaLabel: "Check Today's Sunday Teer Result",
    ctaTo: HOME,
    paragraphs: [
      "The Sunday Teer Result is shown here in a clear, easy-to-read layout so you can check the First Round and Second Round numbers in seconds. We focus on speed and accuracy, updating the moment the official number is declared.",
      "Use the button to view the current Sunday Teer result on the homepage. If you missed an earlier day, our Previous Result archive keeps a full history for you.",
    ],
    related: [
      { label: "Sunday Teer Result Today", to: "/sunday-teer-result-today/" },
      { label: "Sunday Ground Teer Common Number", to: "/sunday-ground-teer-common-number/" },
    ],
  },
  {
    canonicalPath: "/sunday-ground-teer/",
    title: "Sunday Ground Teer – Today's Result & Updates",
    description:
      "Sunday Ground Teer daily result, common number, dream number, previous result archive and a date-wise chart — all in one simple, mobile-friendly place.",
    h1: "Sunday Ground Teer",
    breadcrumb: "Sunday Ground Teer",
    ctaLabel: "Check Today's Result",
    ctaTo: HOME,
    paragraphs: [
      "Sunday Ground Teer is a traditional archery-based number game, and this website is your simple companion for it. Alongside the daily result, you get a Common Number reference, a Dream Number chart, a full Previous Result archive and a date-wise chart.",
      "Start with today's result using the button below, then explore the other sections whenever you like. Everything is free, mobile-friendly and updated regularly.",
    ],
    related: [
      { label: "Sunday Ground Teer Result", to: "/sunday-ground-teer-result/" },
      { label: "Sunday Ground Teer Chart", to: "/sunday-ground-teer-chart/" },
    ],
  },
  {
    canonicalPath: "/sunday-teer-ground/",
    title: "Sunday Teer Ground – Today's Result",
    description:
      "Sunday Teer Ground is another name for the same daily teer draw covered here. Reach today's First Round and Second Round numbers quickly.",
    h1: "Sunday Teer Ground",
    breadcrumb: "Sunday Teer Ground",
    ctaLabel: "Check Today's Result",
    ctaTo: HOME,
    paragraphs: [
      "'Sunday Teer Ground' is another way people refer to the same daily teer draw covered on this site. Here you can quickly reach today's First Round and Second Round numbers and understand how each result is formed.",
      "Hit the button to check the current result. For research, you can also study earlier draws and spot patterns using our previous-result history.",
    ],
    related: [
      { label: "Sunday Ground Teer", to: "/sunday-ground-teer/" },
      { label: "Sunday Ground Teer Previous Result", to: "/sunday-ground-teer-previous-result/" },
    ],
  },
  {
    canonicalPath: "/sunday-teer-result-today/",
    title: "Sunday Teer Result Today – Latest F/R & S/R",
    description:
      "The Sunday Teer Result Today — freshest same-day numbers only. If the draw is still pending you will see a clear 'not declared yet' message.",
    h1: "Sunday Teer Result Today",
    breadcrumb: "Sunday Teer Result Today",
    ctaLabel: "Check Today's Result",
    ctaTo: HOME,
    paragraphs: [
      "This page is dedicated to the Sunday Teer Result Today — the freshest, same-day numbers only. As soon as the day's F/R and S/R are officially announced, they appear on the homepage with the correct date.",
      "We keep things honest: if the day's draw is still pending, you will see a clear 'not declared yet' message instead of any made-up number. Tap below for the live update.",
    ],
    related: [
      { label: "Sunday Teer Result", to: "/sunday-teer-result/" },
      { label: "Sunday Ground Teer Common Number", to: "/sunday-ground-teer-common-number/" },
    ],
  },
  {
    canonicalPath: "/sunday-ground-teer-previous-result/",
    title: "Sunday Ground Teer Previous Result – Result History",
    description:
      "Sunday Ground Teer Previous Result history with past First Round and Second Round numbers organised by date. Filter by year and study earlier draws.",
    h1: "Sunday Ground Teer Previous Result",
    breadcrumb: "Sunday Ground Teer Previous Result",
    ctaLabel: "View Previous Results",
    ctaTo: PREV,
    paragraphs: [
      "The Sunday Ground Teer Previous Result section keeps a history of past First Round and Second Round numbers, organised by date. Reviewing old results is a popular way to study trends before a new draw.",
      "Use the button to open the full previous-result archive, where you can filter by year and load older entries. Remember, past numbers are for study only and do not predict future outcomes.",
    ],
    related: [
      { label: "Sunday Ground Teer Result", to: "/sunday-ground-teer-result/" },
      { label: "Sunday Ground Teer Chart", to: "/sunday-ground-teer-chart/" },
    ],
  },
  {
    canonicalPath: "/sunday-ground-teer-common-number/",
    title: "Sunday Ground Teer Common Number – Today",
    description:
      "Sunday Ground Teer Common Number lists today's most frequent Direct, House and Ending figures from past results. Guidance only — no number is guaranteed.",
    h1: "Sunday Ground Teer Common Number",
    breadcrumb: "Sunday Ground Teer Common Number",
    ctaLabel: "Check Common Number",
    ctaTo: COMMON,
    paragraphs: [
      "The Sunday Ground Teer Common Number lists the most frequently appearing Direct, House and Ending figures for the day, calculated from earlier results. Many players use it as a quick reference point.",
      "Please treat the common number as guidance only — no number is ever guaranteed to win, and teer is a game of chance. Tap the button to view today's common number in detail.",
    ],
    related: [
      { label: "Sunday Ground Teer Result Today", to: "/sunday-ground-teer-result-today/" },
      { label: "Sunday Ground Teer Previous Result", to: "/sunday-ground-teer-previous-result/" },
    ],
  },
  {
    canonicalPath: "/sunday-ground-teer-chart/",
    title: "Sunday Ground Teer Chart – Previous Result Chart",
    description:
      "Sunday Ground Teer Chart lets you look up the result of any specific date. Pick a date and instantly see that day's First and Second Round numbers.",
    h1: "Sunday Ground Teer Chart",
    breadcrumb: "Sunday Ground Teer Chart",
    ctaLabel: "View Sunday Ground Teer Chart",
    ctaTo: CHART,
    paragraphs: [
      "The Sunday Ground Teer Chart lets you look up the result of any specific date. Instead of scrolling through long lists, you pick a date and instantly see that day's First Round and Second Round numbers.",
      "This date-wise chart is handy for comparing results across days and weeks. Use the button below to open the chart and choose your date.",
    ],
    related: [
      { label: "Sunday Ground Teer Previous Result", to: "/sunday-ground-teer-previous-result/" },
      { label: "Sunday Ground Teer Result", to: "/sunday-ground-teer-result/" },
    ],
  },
];
